import React from "react";
import Resolvers from "../../../../../componets/Api/internal/serviceapi/samsung";
import _modalConfirm from "../../../../../componets/BrtxModals/_modalConfirm";
import _modalDocNo from "../../../../../componets/BrtxModals/_modalInputDocNo";
import _modalInputSrvTrk from "../../../../../componets/BrtxModals/_modalInputSrvTrk";
import _modalDateRange from "../../../../../componets/BrtxModals/_modalInputDateRange";
import HistoryModal from "./HistoryModal";
export default class Ticket extends React.Component {
  state = {
    modalConfirm: {
      show: false,
      text: "",
      type: "",
      docno: 0,
      modaltype: "",
      dateFrom: null,
      dateTo: null,
    },
    history: {
      show: false,
      items: [],
    },
  };

  renderLabel(x) {
    switch (x) {
      case "200":
        return "lb-success-3";
      case "999":
        return "lb-secondary-3";
      default:
        return "lb-danger-3";
    }
  }

  stAction = async (type, docNo, e = "") => {
    let _res;
    switch (type) {
      case "newsrvtrk":
        _res = await Resolvers({
          ...this.props,
          NewSrvTrk: true,
          docno: docNo,
          srvtrk: e,
        });
      case "history":
        _res = await this.history(docNo);
      default:
        _res = await Resolvers({
          ...this.props,
          Process: true,
          docno: docNo,
          processType: type,
        });
    }

    if (type !== "history") this.props.refresh();
    return _res;
  };

  history = async (docNo) => {
    this.setState({ history: { show: true, items: [] } });
    var _res = await Resolvers({ ...this.props, History: true, docno: docNo });
    this.setState({ history: { ...this.state.history, items: _res.data } });
    return _res;
  };

  modalConfirmReturn = (e, type, docno) => {
    if (e) {
      this.stAction(type, docno, e);
    }

    this.setState({
      modalConfirm: {
        show: false,
        text: "",
        type: "",
        docno: 0,
        modaltype: "",
        dateFrom: null,
        dateTo: null,
      },
    });
  };

  renderInfo(e) {
    return (
      "Druh záruky IGSPN: " +
      e.warrantyTerm +
      "</br>Opakovaná oprava IGSPN: " +
      e.repeatRepair +
      "<br>Druh opravy S21: " +
      e.repType +
      "<br><br>Poslední odeslání: " +
      new Date(e.dateLock).toLocaleString()
    );
  }

  render() {
    const { Bs, VARIANT, SIZE, _icon } = this.props;
    return (
      <>
        {this.state.history.show && (
          <HistoryModal
            onHide={() =>
              this.setState({ history: { show: false, items: [] } })
            }
            {...this.props}
            {...this.state}
          />
        )}
        {this.state.modalConfirm.modaltype === "confirm" && (
          <_modalConfirm
            {...this.props}
            {...this.state}
            returnConfirmModal={this.modalConfirmReturn}
          />
        )}
        {this.state.modalConfirm.modaltype === "SrvTrkInput" && (
          <_modalInputSrvTrk
            {...this.props}
            {...this.state}
            returnConfirmModal={this.modalConfirmReturn}
          />
        )}

        {this.props.tickets.map((e) => (
          <Bs row className="mb-2">
            <Bs
              card
              bg={VARIANT.WHITE}
              className={this.renderLabel(e.ResCode)}
            >
              <Bs cardbody>
                <Bs row>
                  <Bs col xs={10} lg={5}>
                    <Bs row className="d-flex">
                      <Bs span>
                        <_icon
                          aioutlineinfocircle
                          className="c-secondary me-2 fs-20"
                          data-tip={this.renderInfo(e)}
                        />
                        <Bs strong className="me-4">
                          {e.docNo}
                        </Bs>
                        <Bs small className="ms-4 text-muted">
                          {e.status} / {e.reason}
                        </Bs>
                      </Bs>
                    </Bs>
                    <Bs row>
                      <Bs small className="o-el" data-tip={e.ErrorST}>
                        {e.ErrorST}
                      </Bs>
                    </Bs>
                  </Bs>
                  <Bs col xs={2} className="d-flex justify-content-center">
                    <Bs dropdown>
                      <Bs
                        dropdowntoggle
                        variant={VARIANT.LIGHT}
                        className="pt-2"
                        data-tip={e.TrNo ? "Tracking č.: " + e.TrNo : ""}
                      >
                        <_icon
                          gideertrack
                          className={
                            e.TrNo ? "fs-20 c-success" : "fs-20 text-muted"
                          }
                        />
                      </Bs>
                      <Bs dropdownmenu className="p-2">
                        <Bs dropdownheader>Service Tracking</Bs>
                        {e.TrNo && (
                          <Bs
                            dropdownitem
                            eventKey="2"
                            onClick={() => {
                              window.navigator.clipboard.writeText(e.TrNo);
                              this.props.setToast(
                                "Číslo trackingu bylo zkopírováno do schránky.",
                                "Schránka",
                                "secondary"
                              );
                            }}
                          >
                            Kopírovat do schránky
                          </Bs>
                        )}

                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() =>
                            this.setState({
                              modalConfirm: {
                                show: true,
                                type: "newsrvtrk",
                                modaltype: "SrvTrkInput",
                                text:
                                  "Zapiš nové číslo trackingu pro zakázku č.: <b>" +
                                  e.docNo +
                                  "</b>",
                                docno: e.docNo,
                              },
                            })
                          }
                        >
                          Přiřadit nové číslo ST
                        </Bs>
                      </Bs>
                    </Bs>

                    <Bs
                      button
                      size={SIZE.SM}
                      variant={VARIANT.LIGHT}
                      data-tip={
                        e.comment
                          ? "Zobrazit komentáře - (Poslední komentář: " +
                            e.comment +
                            ")"
                          : ""
                      }
                    >
                      <_icon
                        gocommentdiscussion
                        className={
                          e.comment !== null
                            ? "fs-20 c-danger"
                            : "fs-20 c-secondary"
                        }
                      />
                      {e.comment !== null && (
                        <Bs badge pill bg={VARIANT.DANGER} className="p-tr">
                          1
                        </Bs>
                      )}
                    </Bs>
                  </Bs>
                  <Bs
                    col
                    xs={12}
                    lg={5}
                    className="d-flex justify-content-end"
                  >
                    <Bs
                      button
                      size={SIZE.SM}
                      variant={VARIANT.LIGHT}
                      className="me-4"
                      onClick={() => {
                        this.setState({
                          modalConfirm: {
                            show: true,
                            type: "voidc",
                            modaltype: "confirm",
                            text:
                              "Opravdu chceš nastavit pro report zakázky č.: <b>" +
                              e.docNo +
                              "</b> VOID-C ?",
                            docno: e.docNo,
                          },
                        });
                      }}
                      data-tip={
                        e.voidC
                          ? "Zrušit reportování voidu C"
                          : "Reportovat jako VOID-C"
                      }
                    >
                      <_icon
                        aifillcopyrightcircle
                        className={
                          e.voidC ? "fs-20 c-success" : "fs-20 c-secondary"
                        }
                      />
                    </Bs>
                    {e.ResCode !== "200" && e.ResCode !== "999" && (
                      <Bs
                        button
                        size={SIZE.SM}
                        variant={VARIANT.LIGHT}
                        data-tip="Znovu odeslat"
                        onClick={() =>
                          this.setState({
                            modalConfirm: {
                              show: true,
                              type: "refresh",
                              modaltype: "confirm",
                              text:
                                "Opravdu chceš znovu odeslat zakázku č.: <b>" +
                                e.docNo +
                                "</b>",
                              docno: e.docNo,
                            },
                          })
                        }
                      >
                        <_icon iorefreshoutline className="fs-20" />
                      </Bs>
                    )}

                    <Bs
                      button
                      size={SIZE.SM}
                      variant={VARIANT.LIGHT}
                      data-tip="Historie odesílání"
                      onClick={() => this.stAction("history", e.docNo)}
                    >
                      <_icon bslist className="fs-20" />
                    </Bs>
                    <Bs dropdown>
                      <Bs
                        dropdowntoggle
                        variant={VARIANT.LIGHT}
                        className="pt-2"
                        data-tip="Změnit krok reportu"
                      >
                        <_icon cgarrowsexchangealt className="fs-20" />
                      </Bs>
                      <Bs dropdownmenu className="p-2">
                        <Bs dropdownheader>Změnit krok reportu</Bs>
                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => this.stAction("set_st010", e.docNo)}
                        >
                          Poslat znovu ST010 (Založení ST)
                        </Bs>
                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => console.log("new")}
                        >
                          Poslat díly a vrátit do chyb
                        </Bs>

                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => console.log("new")}
                        >
                          Přehodit do ST015 (Skip SAW na prodloužení záruky)
                        </Bs>
                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => console.log("new")}
                        >
                          Nastav stav ST035 (Výrobce přehodil do ST035)
                        </Bs>
                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => console.log("new")}
                        >
                          Oprava dokončena (Poslat stav ST035)
                        </Bs>
                        <Bs dropdowndivider />
                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => console.log("new")}
                        >
                          Zakázka ručně dokončena
                        </Bs>
                        <Bs dropdowndivider />
                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => console.log("new")}
                        >
                          STORNO NA GSPN (Výrobce přehodil do ST035)
                        </Bs>
                      </Bs>
                    </Bs>
                    {e.ResCode !== "200" && e.ResCode !== "999" && (
                      <Bs
                        button
                        size={SIZE.SM}
                        variant={VARIANT.LIGHT}
                        data-tip="Označit jako úspěšný"
                        onClick={() =>
                          this.setState({
                            modalConfirm: {
                              show: true,
                              type: "skiperror",
                              modaltype: "confirm",
                              text:
                                "Opravdu chceš označit chybu jako úspěšné odeslání zakázky č.: <b>" +
                                e.docNo +
                                "</b>",
                              docno: e.docNo,
                            },
                          })
                        }
                      >
                        <_icon bsskipforward className="fs-20" />
                      </Bs>
                    )}
                    <Bs dropdown>
                      <Bs
                        dropdowntoggle
                        variant={VARIANT.LIGHT}
                        className="pt-2"
                        data-tip="Další možnosti"
                      >
                        <_icon aioutlinemore className="fs-20" />
                      </Bs>
                      <Bs dropdownmenu className="p-2">
                        <Bs dropdownheader>Další možnosti</Bs>
                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => console.log("new")}
                        >
                          Odeslat přes nový systém
                        </Bs>
                        <Bs
                          dropdownitem
                          eventKey="2"
                          onClick={() => console.log("new")}
                        >
                          Uploadovat soubor
                        </Bs>
                      </Bs>
                    </Bs>
                  </Bs>
                </Bs>
              </Bs>
            </Bs>
          </Bs>
        ))}
      </>
    );
  }
}
